import React from "react";
import {
  Box,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  Link as MuiLink,
} from "@mui/material";
import { AccountBalance } from "@mui/icons-material";
import meetMark  from "../images/about_deb_bg.jpg";

const CommittingToTransparencyAndAccountability = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <div>
      <Box
        pt={2}
        sx={{
          background: `url(${meetMark })`,
          backgroundSize: "cover",
          height: "100vh",
          minHeight: "fit-content",
        }}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Grid
          container
          mt={8}
          py={6}
          sx={{width: isMobile ?  "75vw" : "50vw" }}
          display="flex"
          flexDirection="column"
          alignItems="stretch"
        >
          <MuiLink
            href="/priorities"
            underline="none"
            color="white"
            sx={{ mb: 2, fontSize: "1rem" }}
          >
            ← Back to Priorities
          </MuiLink>

          <Grid item display="flex" alignItems="center" gap={2}>
            <AccountBalance sx={{ fontSize: "3rem", color: "white" }} />
            <Typography
              variant="h1"
              sx={{ fontSize: "2.5rem!important", color: "white!important" }}
            >
              Committing to Transparency and Accountability
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          p={6}
        >
          <Grid item sx={contentBox(isMobile)}>
            <Typography variant="p" color="white">
              As County Executive, Mark will fight for you and not the special interests. For too long special interests have exerted outsized influence on important County decisions. Mark has spent her Council career championing a fairer playing field for businesses and the community.
            </Typography>
          </Grid>

          <Grid item sx={sectionHeader(isMobile)}>
            <Typography variant="h3" color="white">
              Deb’s Record:
            </Typography>
          </Grid>

          <Grid item sx={contentBox(isMobile)}>
            <List>
              <Bullet text="Repealed legislation that provided sweetheart deals so that land-use decisions don’t favor one developer over another or over the community." />
              <Bullet text="Strengthened the County’s public campaign financing program (Citizens Election Fund) to make it more supportive of candidates who opt out of taking special interest money." />
              <Bullet text="Modernized the County’s Zoning Board process so that special interests no longer exercise undue influence." />
              <Bullet text="Altered the criteria for sole-source purchases to prevent an outsized benefit for private entities when building public amenities." />
              <Bullet text="Built unanimous support for a Charter amendment and an implementing ordinance creating an independent Office of Inspector General to investigate waste, fraud, and abuse." />
              <Bullet text="Sponsored the removal of the exemption for sole source contracts to pay their employees less than Howard County’s Living Wage." />
              <Bullet text="Voted against zoning changes that would solely benefit developers without truly benefitting the public." />
            </List>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

const Bullet = ({ text }) => (
  <ListItem disablePadding>
    <ListItemText primary={text} />
  </ListItem>
);

const contentBox = (isMobile) => ({
  fontStyle: "normal",
  fontWeight: "500",
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "16px",
  lineHeight: "1.6875",
  letterSpacing: "0em",
  maxWidth: isMobile ? "auto" : "50vw",
  textAlign: "left",
  mb: 2,
  color: "white!important",
});

const sectionHeader = (isMobile) => ({
  fontWeight: "600",
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "24px",
  lineHeight: "1.6875",
  maxWidth: isMobile ? "auto" : "50vw",
  textAlign: "left",
  mt: 4,
  mb: 4,
});

export default CommittingToTransparencyAndAccountability;
